
import Vue from "vue";

export default Vue.component("SHTableSkeleton", {
  components: {
    QSkeleton: () => import("../elements/QSkeleton.vue"),
  },
});
